"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _projectManageApi = require("@/api/projectManageApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ProjectCardEdit',
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      submitLoading: false,
      currentRowData: null,
      projectId: '',
      currentCardId: '',
      form: {
        id: '',
        remark: '',
        channelNameList: ''
      },
      rules: {
        id: [{
          required: true,
          message: '请选择福卡',
          trigger: 'change'
        }]
      },
      cardOptions: [],
      operationLogs: []
    };
  },
  computed: {
    isCurrentCard: function isCurrentCard() {
      if (this.form.id === '' || this.form.id === null || this.form.id === undefined) {
        return true;
      }
      return String(this.form.id) === String(this.currentCardId);
    }
  },
  methods: {
    open: function open(row) {
      this.dialogVisible = true;
      this.currentRowData = row;
      // console.log('row', row);
      this.projectId = row.id;
      // 初始化表单数据
      // this.initFormData(row);

      // 获取详情和福卡列表
      this.getProjectCardDetail();
      this.getCardList();
    },
    close: function close() {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm: function resetForm() {
      this.form = {
        id: '',
        remark: '',
        channelNameList: ''
      };
      this.currentRowData = null;
      this.currentCardId = '';
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    // initFormData(row) {
    //   if (row) {
    //     this.form = {
    //       currentCard: row.fuCardId || 'ID-13',
    //       usageDescription: row.usageDescription || '红丫优选特权卡',
    //       sourceWeight: row.sourceWeight || '电影频道,在线商城,红丫-核销支持,红丫-生日频道-甲类频道,作弊检测,无超市卡'
    //     };
    //   }
    // },
    onCardChange: function onCardChange(value) {
      console.log('选择的福卡ID:', value);
      // 可以根据选择的福卡获取更多详细信息
    },
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.$refs.formRef.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
                  var data, _t;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.p = _context.n) {
                      case 0:
                        if (valid) {
                          _context.n = 1;
                          break;
                        }
                        return _context.a(2);
                      case 1:
                        _this.submitLoading = true;
                        _context.p = 2;
                        // 构建提交数据
                        data = {
                          customerIntegralId: _this.projectId,
                          fuCardId: _this.form.id
                        };
                        console.log('提交福卡信息数据:', data);

                        // 调用变更福卡接口
                        _context.n = 3;
                        return (0, _projectManageApi.editFudouCard)(data);
                      case 3:
                        _this.$message.success('保存成功');
                        _this.close();
                        _this.$emit('refresh');
                        _context.n = 5;
                        break;
                      case 4:
                        _context.p = 4;
                        _t = _context.v;
                        console.error('保存失败:', _t);
                        _this.$message.error('保存失败: ' + (_t.message || '未知错误'));
                      case 5:
                        _context.p = 5;
                        _this.submitLoading = false;
                        return _context.f(5);
                      case 6:
                        return _context.a(2);
                    }
                  }, _callee, null, [[2, 4, 5, 6]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    // 获取项目福卡详情
    getProjectCardDetail: function () {
      var _getProjectCardDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$currentRowData, _this$currentRowData2, response, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.loading = true;
              _context3.p = 1;
              console.log('获取项目福卡详情，项目ID:', (_this$currentRowData = this.currentRowData) === null || _this$currentRowData === void 0 ? void 0 : _this$currentRowData.id);
              _context3.n = 2;
              return (0, _projectManageApi.getProjectCardDetailApi)((_this$currentRowData2 = this.currentRowData) === null || _this$currentRowData2 === void 0 ? void 0 : _this$currentRowData2.id);
            case 2:
              response = _context3.v;
              console.log('获取到的福卡详情:', response);

              // 更新表单数据
              this.form = response;
              this.currentCardId = response && response.id;
              // if (response && response.data) {
              //   this.form.currentCard = response.data.fuCardId || 'ID-13';
              //   this.form.usageDescription = response.data.usageDescription || '红丫优选特权卡';
              //   this.form.sourceWeight = response.data.sourceWeight || '电影频道,在线商城,红丫-核销支持,红丫-生日频道-甲类频道,作弊检测,无超市卡';
              // }

              console.log('福卡详情获取完成');
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              console.error('获取福卡详情失败:', _t2);
              this.$message.error('获取详情失败');
            case 4:
              _context3.p = 4;
              this.loading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function getProjectCardDetail() {
        return _getProjectCardDetail.apply(this, arguments);
      }
      return getProjectCardDetail;
    }(),
    // 获取福卡列表
    getCardList: function () {
      var _getCardList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _projectManageApi.getCardListApi)();
            case 1:
              res = _context4.v;
              // console.log('获取到的福卡列表:', res);
              this.cardOptions = res || [];

              // console.log('福卡列表获取完成:', this.cardOptions);
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              console.error('获取福卡列表失败:', _t3);
              this.$message.error('获取福卡列表失败');
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function getCardList() {
        return _getCardList.apply(this, arguments);
      }
      return getCardList;
    }()
  },
  // 进入页面时自动调用接口
  created: function created() {
    console.log('ProjectCardEdit 组件已创建');
  }
};